import { Component, computed, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SoftwareInventory } from '../../../../../Models/avyna/agent-device.model';
import { AvContentContainerComponent } from '../../../../Shared/Components/av-content-container/av-content-container.component';
import { AvTableCard } from '../../../../Shared/Components/av-table-card/av-table-card.component';
import { AvTableColumn, AvTableRow } from '../../../../Shared/Interfaces/av-table-card.interface';
import { ShowDeviceFacade } from '../../../../../Facades/Intune/show-device.facade';

@Component({
  selector: 'app-applications',
  standalone: true,
  imports: [AvContentContainerComponent, AvTableCard],
  templateUrl: './applications.component.html',
  styleUrls: ['./applications.component.scss'],
})
export class ApplicationsComponent {
  private readonly _facade = inject(ShowDeviceFacade);
  private readonly translate = inject(TranslateService);

  readonly device = this._facade.device;

  readonly softwareColumns: AvTableColumn[] = [
    { key: 'name', label: 'app.device.applications.columns.name', sortable: true },
    { key: 'version', label: 'app.device.applications.columns.version', sortable: true },
    { key: 'publisher', label: 'app.device.applications.columns.publisher', sortable: true },
  ];

  readonly softwareRows = computed<AvTableRow[]>(() => {
    const items = this.device()?.agent?.applications?.software_inventory;
    if (!Array.isArray(items)) return [];

    return items.map((item: SoftwareInventory) => ({
      name: this.fallbackString(item?.name),
      version: this.fallbackString(item?.version),
      publisher: this.fallbackString(item?.publisher),
    }));
  });

  private fallbackString(value?: string | null): string {
    if (value && value.trim().length > 0) return value;
    return this.translate.instant('shared.general.labels.na');
  }
}
